import { filterResourceContentByLanguage } from '@components/DynamicForm/helpers'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AutosaveStatus, EditorState, StringTemplateVariable } from './types'

const initialState: EditorState = {
  variables: [],
  variablesLoading: false,
  variablesError: undefined,
  activeEditorInstance: null,
  activeEditorSelectionRange: null,
  isDirty: false,
  isUnsavedChangesModal: false,
  initialResourceData: null,
  initialFilteredResourceData: null,
  template: null,
  autosaveStatus: 'idle',
  autosaveLastSavedAt: null,
}

const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setVariables(state, action: PayloadAction<StringTemplateVariable[]>) {
      state.variables = action.payload
      state.variablesLoading = false
    },
    setVariablesError(state, action: PayloadAction<string>) {
      state.variablesError = action.payload
      state.variablesLoading = false
    },
    setActiveEditor(
      state,
      action: PayloadAction<{
        activeEditorInstance: any
        activeEditorSelectionRange: any
      }>,
    ) {
      state.activeEditorInstance = action.payload.activeEditorInstance
      state.activeEditorSelectionRange =
        action.payload.activeEditorSelectionRange
    },
    setEditorIsDirty(state, action: PayloadAction<boolean>) {
      state.isDirty = action.payload
    },
    setIsUnsavedChangesModal(
      state,
      action: PayloadAction<{
        isUnsavedChangesModal: boolean
        unsavedChangesDiscardAction?: () => void
      }>,
    ) {
      state.isUnsavedChangesModal = action.payload.isUnsavedChangesModal
      state.unsavedChangesDiscardAction =
        action.payload.unsavedChangesDiscardAction
    },
    setInitialResourceData(state, action: PayloadAction<any>) {
      const filteredResourceData = filterResourceContentByLanguage({
        resource: action.payload.resource,
        currentLanguageTag: action.payload.languageTag,
      })
      state.initialResourceData = action.payload.resource
      state.initialFilteredResourceData = filteredResourceData
    },
    setEditorTemplate(state, action: PayloadAction<any>) {
      state.template = action.payload
    },
    setAutosaveStatus(state, action: PayloadAction<AutosaveStatus>) {
      state.autosaveStatus = action.payload
      if (action.payload === 'saved') {
        state.autosaveLastSavedAt = Date.now()
      }
      if (action.payload === 'idle') {
        state.autosaveLastSavedAt = null
      }
    },
  },
})

export default editorSlice.reducer

export const {
  setVariables,
  setVariablesError,
  setActiveEditor,
  setEditorIsDirty,
  setIsUnsavedChangesModal,
  setInitialResourceData,
  setEditorTemplate,
  setAutosaveStatus,
} = editorSlice.actions
